<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!--      <div class="col-xl-3">-->
      <!--        <BranchStatsPanel />-->
      <!--      </div>-->
      <!-- end col -->
      <div class="col-12 col-sm-12 col-md-12 col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Create Customer</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <CreateCustomerForm />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>

import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import CreateCustomerForm from "../../components/Kleyton/Forms/Customer/CreateCustomerForm";

export default {
  page: {
    title: "Create Customer",
    meta: [{ name: "Create Customer", content: window.__env.app.description }]
  },

  components: {
    CreateCustomerForm,
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "CreateCustomer",
      title: "Create Customer",
      items: [
        {
          text: "Customer",
          href: "/"
        },
        {
          text: "Create Customer",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
